import SensitivityBadge from "../../../components/shared/Badge/SensitivityBadge";

export function DriveSensitivityBadge({ drive }) {
  const sensitivity_count_high = Number(drive.highSensitivityFiles || 0);
  const sensitivity_count_medium = Number(drive.mediumSensitivityFiles || 0);
  const sensitivity_count_low = Number(drive.lowSensitivityFiles || 0);
  const sensitivity_count_not_processed = Number(
    drive.noSensitivityFiles || 0
  );

  const total_sensitivity_count =
    sensitivity_count_high +
    sensitivity_count_medium +
    sensitivity_count_low +
    sensitivity_count_not_processed;

  if (total_sensitivity_count === 0) {
    return <div className="no-sensitivity">No Sensitivity Data</div>;
  }

  const sensitiveFormatData = {
    sensitivity_count_high,
    sensitivity_count_medium,
    sensitivity_count_low,
    sensitivity_count_not_processed,
    total_sensitivity_count,
  };

  return (
    <SensitivityBadge
      parentprops={sensitiveFormatData}
      loc="DataTagDrives"
      title="Sensitivity:"
    />
  );
}
